import { ButtonProps, ButtonType, ButtonWidget, Img, InteractionState } from '@tableau/widgets';
import React from 'react';

import { CommonStyles } from '../../common/react/CommonStyles';
import { imgPath } from '../../common/utilities/ImgUrl';
import { DeviceType } from '../../ts/models/DeviceType';

export function DeviceItem(props: DeviceItem.Props):
    React.ReactElement<DeviceItem.Props> {

  interface Icon {
    height: number;
    width: number;
    iconSrcPath: (state: InteractionState) => string;
  }
  const { onDeviceTypeClick, isSelected, device, message } = props;

  const ACTIVE_ICON_FILE = `${device}_active.svg`;
  const DEFAULT_ICON_FILE = `${device}_default.svg`;

  const DEFAULT_ICON_PATH = imgPath(DEFAULT_ICON_FILE);
  const ACTIVE_ICON_PATH = imgPath(ACTIVE_ICON_FILE);

  const deviceClick = () => {
    onDeviceTypeClick(device);
  };

  const style: React.CSSProperties = {
    display: 'inline-flex',
    verticalAlign: 'top',
    borderBottom: isSelected ? `3px solid ${CommonStyles.Colors.DiscreteBlue}` : 'none',
    color: CommonStyles.Colors.Grey230,
    fontSize: 14,
    fontWeight: isSelected ? 'bold' : 'normal',
    paddingRight: CommonStyles.Sizes.DefaultSpace,
    cursor: 'pointer'
  };

  const testId = `device-icon-${device}`;

  const PreviewDeviceIcon: Icon = {
    height: 20,
    width: 30,
    iconSrcPath: (state: InteractionState) => {
      return getHoverState(state) ? ACTIVE_ICON_PATH : DEFAULT_ICON_PATH;
    }
  };

  const iconButtonProps: ButtonProps = {
    buttonType: ButtonType.IconOutline,
    getContent: getContent(PreviewDeviceIcon),
    testId: testId,
    handleClick: deviceClick,
    style: style,
    title: message
  };

  function getHoverState(state: InteractionState): boolean {
    return state.hover;
  }

  function getContent(icon: Icon): ((state: InteractionState) => JSX.Element) {
    return (state: InteractionState): JSX.Element => {
      style.color = getHoverState(state) ? CommonStyles.Colors.Grey230 : CommonStyles.Colors.Grey245;

      const imgProps: React.ImgHTMLAttributes<HTMLImageElement> = {
        draggable: false,
        height: icon.height,
        width: icon.width,
        src: icon.iconSrcPath(state),
        style: {
          marginLeft: '-2px', // This is to account for the image asset being offcentered
          marginRight: '6px',
          cursor: 'pointer'
        }
      };

      return (
        <React.Fragment>
          <Img {...imgProps} />
          { message }
        </React.Fragment>
      );
    };
  }
  return (
    <span className="tab-device-icon" role="tab">
      <ButtonWidget {...iconButtonProps} />
    </span>
  );

}

export namespace DeviceItem {
  export interface Props {
    device: DeviceType;
    isSelected: boolean;
    onDeviceTypeClick: (device: DeviceType) => void;
    message: string;
  }
}
